/**
 * 실시간 시간/날짜 관리 Composable
 * 목적: 현재 시간과 날짜를 실시간으로 업데이트하여 제공
 */
export const useRealTime = () => {
  /**
   * 현재 시간 상태 (HH:MM:SS 형식)
   * 목적: 실시간으로 업데이트되는 현재 시간 표시
   */
  const currentTime = ref('');

  /**
   * 현재 날짜 상태 (YYYY년 MM월 DD일 형식)
   * 목적: 실시간으로 업데이트되는 현재 날짜 표시
   */
  const currentDate = ref('');

  /**
   * 시간 업데이트 인터벌 ID
   * 목적: 컴포넌트 언마운트시 인터벌 정리용
   */
  let timeInterval = null;

  /**
   * 현재 시간과 날짜를 업데이트하는 함수
   * 목적: Date 객체에서 시간/날짜 정보를 추출하여 포맷팅
   */
  const updateTime = () => {
    const now = new Date();

    // 시간 포맷: HH:MM:SS
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    currentTime.value = `${hours}:${minutes}:${seconds}`;

    // 날짜 포맷: YYYY년 MM월 DD일
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const date = String(now.getDate()).padStart(2, '0');
    currentDate.value = `${year}년 ${month}월 ${date}일`;
  };

  /**
   * 실시간 시간 업데이트 시작
   * 목적: 1초마다 시간과 날짜를 업데이트
   */
  const startRealTime = () => {
    // 즉시 한 번 실행
    updateTime();

    // 1초마다 업데이트
    timeInterval = setInterval(updateTime, 1000);
  };

  /**
   * 실시간 시간 업데이트 중지
   * 목적: 메모리 누수 방지를 위한 인터벌 정리
   */
  const stopRealTime = () => {
    if (timeInterval) {
      clearInterval(timeInterval);
      timeInterval = null;
    }
  };

  // 컴포넌트 마운트시 자동 시작
  onMounted(() => {
    startRealTime();
  });

  // 컴포넌트 언마운트시 자동 정리
  onUnmounted(() => {
    stopRealTime();
  });

  return {
    currentTime: readonly(currentTime),
    currentDate: readonly(currentDate),
    startRealTime,
    stopRealTime
  };
};
